// The same class is used to adding a payee as well as adding a company manually
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import MoveMoneyPayeeStore from '../../stores/MoveMoneyPayeeStore';

import { setSMEPaymentToAccount } from '../../actions/MoveMoneySMEActionCreator';
import MoveMoneyPayeeActionCreator from '../../actions/MoveMoneyPayeeActionCreator';
import AddPayeeSummary from './AddPayeeSummary';
import LoaderComponent from '../common/LoaderComponent';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';
import AnalyticsUtil from '../../utils/AnalyticsUtil';
import config from '../../config/index';
import StepHeader from '../../includes/StepHeader';
import NumberUtils from '../../utils/NumberUtils';
import RegexUtils from '../../utils/RegexUtils';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import { beneficiaryCreateEventPayload } from '../../logic/BeneficiaryEventsBusinessLogic';
import { isBOrVMRetail } from '../../utils/BrandUtils';
import { Popover } from 'web-ui-components/lib/atoms/popovers';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { ConditionalPanel } from 'web-ui-components/lib/layout/content';

let doErrorExist = false;

class AddPersonComponent extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.sortKeyUp = this.sortKeyUp.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.goBackToMoveMoney = this.goBackToMoveMoney.bind(this);
    this.addPayeeConfirm = this.addPayeeConfirm.bind(this);
    this.updateValueState = this.updateValueState.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.getRenderContent = this.getRenderContent.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.checkForError = this.checkForError.bind(this);
    this.goToManagePayees = this.goToManagePayees.bind(this);
    this.goToMoveMoneyPage = this.goToMoveMoneyPage.bind(this);
    this.showHeader = this.showHeader.bind(this);
    this.handleRadioClick = this.handleRadioClick.bind(this);
    this.updateStore = this.updateStore.bind(this);
    this.getNameHeader = this.getNameHeader.bind(this);
    this.getNameHelperText = this.getNameHelperText.bind(this);
    this.getFormatedSortCode = this.getFormatedSortCode.bind(this);
    this.removeHypenFromString = this.removeHypenFromString.bind(this);
    this.isAddingSameAccount = this.isAddingSameAccount.bind(this);
    this.showHideInlineError = this.showHideInlineError.bind(this);
    this.moveFocusOnSortCode = this.moveFocusOnSortCode.bind(this);

    this.state = {
      name: '',
      sort_code: '',
      display_name: '',
      reference: '',
      account_number: '',
      addPayeeFlag: true,
      addPayeeConfirmFlag: false,
      showPayeeFlag: false,
      isNicknameEnable: this.props.isFromManagePayee,
      showPayeeSummaryPage: false,
      showLoader: false,
      showError: false,
      summaryDetails: '',
      addPayeeError: false,
      addPayeeResponse: '',
      showHedaerResponse: '',
      fieldBlurred: {
        name: false,
        sort_code: false,
        account_number: false,
        reference: false,
        display_name: false,
      },
      fieldValid: {
        name: false,
        sort_code: false,
        account_number: false,
        reference: false,
        display_name: false,
      },
      showMoreInfo: false,
      callCOP: false,
      showBackButtonOnTop: false,
    };
  }
  //TODO: refactor in constructor
  componentWillMount() {
    const { selectedPayee, comingFromCompanySearch, manualDetails } =
      this.props;
    if (comingFromCompanySearch) {
      this.setState(() => ({
        sort_code: manualDetails.sortCode,
        account_number: manualDetails.accountNumber,
        name: manualDetails.companyText,
        fieldValid: {
          name: manualDetails.companyText ? true : false,
          account_number: manualDetails.accountNumber ? true : false,
          sort_code: manualDetails.sortCode ? true : false,
        },
      }));
    }
    if (this.props.displayLoader) {
      this.setState({ showLoader: true });
    }
    if (this.props.isEditCOP) {
      const {
        account_number,
        display_name,
        name,
        reference,
        single_use,
        sort_code,
      } = MoveMoneyPayeeStore.getAddPayeeDetails();
      this.setState({
        account_number: account_number,
        sort_code: sort_code,
        reference: reference,
        name: name,
        isNicknameEnable: !single_use,
        display_name: display_name,
      });
      const validField = {
        name: true,
        sort_code: true,
        account_number: true,
        reference: true,
        display_name: !single_use,
      };
      this.setState({ fieldValid: validField });
    }
    if (selectedPayee && !this.props.accntSelection) {
      const {
        display_name,
        name,
        reference,
        account: { account_number, sort_code },
      } = selectedPayee;
      this.setState({
        sort_code: sort_code,
        account_number: account_number,
        name: name,
        reference: reference,
        isNicknameEnable: true,
        display_name: display_name,
        fieldValid: {
          name: true,
          sort_code: true,
          account_number: true,
          reference: true,
          display_name: true,
        },
      });
    }
    MoveMoneyPayeeStore.addChangeListener(this.onStoreChange);
  }

  componentDidMount() {
    sayLandingMessage(this.props.content.payeeHeader);

    if (this.props.isEditCOP) {
      const {
        account_number,
        display_name,
        name,
        reference,
        single_use,
        sort_code,
      } = MoveMoneyPayeeStore.getAddPayeeDetails();

      const validField = {
        name: true,
        sort_code: true,
        account_number: true,
        reference: true,
        display_name: !single_use,
      };

      this.setState({
        account_number,
        display_name,
        fieldValid: validField,
        isNicknameEnable: !single_use,
        name,
        reference,
        sort_code,
      });
    }
  }

  componentWillUnmount() {
    MoveMoneyPayeeStore.removeChangeListener(this.onStoreChange);
  }

  onBlur(e) {
    const parent =
      e.currentTarget.attributes.getNamedItem('data-parent').textContent;
    const name = e.target.name;
    this.updateValueState(e.target.name, e.target.value.trim());
    if (
      e.target.name === this.props.content.payeeRequestPacket_sort_code &&
      e.target.value !== '' &&
      e.target.value.length === 6
    ) {
      const tempRemoveHypen = NumberUtils.formatSortCode(e.target.value);
      this.updateValueState(e.target.name, tempRemoveHypen);
    }
    this.state.fieldBlurred[name] = true;
    this.showHideInlineError(
      parent,
      name,
      !this.state.fieldValid[e.target.name]
    );
  }

  onChange(e) {
    // Getting the name and Value of input changed
    const parent =
      e.currentTarget.attributes.getNamedItem('data-parent').textContent;

    switch (e.target.name) {
      case 'name':
        let nameRes = String(e.target.value).match(
          /^[0-9A-Za-z&()\\._/ -]{0,138}/
        );
        let nameData = nameRes[0].replace(/\s\s+/g, ' ');
        if (nameData.length > 0 && nameData.charAt(0) === ' ') {
          nameData = nameData.trim();
        }
        this.updateValueState(e.target.name, nameData);
        this.checkError(e.target.name, nameData, parent);
        break;
      case 'sort_code':
        let value = String(e.target.value);
        value = this.removeHypenFromString(value);
        let res = value.match(/^[0-9]{0,6}/);
        this.updateValueState(e.target.name, res[0]);
        this.checkError(e.target.name, res[0], parent);
        const sortCodeValid = this.state.fieldValid['sort_code'];
        if (
          this.state.addPayeeResponse === 'Invalid Account' &&
          sortCodeValid
        ) {
          this.showHideInlineError('accNumErr', 'account_number', false);
        }
        this.props.keyFieldsChanged();

        break;
      case 'account_number':
        let accRes = e.target.value.match(/^[0-9]{0,8}/);
        this.updateValueState(e.target.name, accRes[0]);
        this.checkError(e.target.name, accRes[0], parent);
        const accountValid = this.state.fieldValid['account_number'];
        if (this.state.addPayeeResponse === 'Invalid Account' && accountValid) {
          this.showHideInlineError('sortCodeErr', 'sort_code', false);
        }
        this.props.keyFieldsChanged();
        break;
      case 'reference':
        const expression = RegexUtils.regexes.referenceRegex;
        const refRes = String(e.target.value).match(expression);
        let refData = refRes[0].replace(/\s\s+/g, ' ');
        if (refData.length > 0 && refData.charAt(0) === ' ') {
          refData = refData.trim();
        }
        this.checkError(e.target.name, refData, parent);
        this.updateValueState(e.target.name, refData);
        break;
      case 'display_name':
        const regExp = RegexUtils.regexes.nicknameRegex;
        const nicknameRes = String(e.target.value).match(regExp);
        let nicknameData = nicknameRes[0].replace(/\s\s+/g, ' ');
        if (nicknameData.length > 0 && nicknameData.charAt(0) === ' ') {
          nicknameData = nicknameData.trim();
        }
        this.updateValueState(e.target.name, nicknameData);
        this.checkError(e.target.name, nicknameData, parent);
        break;
      default:
        break;
    }
  }

  onStoreChange() {
    let response = MoveMoneyPayeeStore.getAddPayeeResponse();
    const {
      isSMEUser,
      isFromManagePayee,
      content: { IncorrectFormatPayeeErrorMsg, duplicatePayeeErrrmsg },
    } = this.props;
    if (response.code === 201) {
      if (isSMEUser && !isFromManagePayee) {
        this.handleSMEAddPayee(response);
      } else {
        this.setState({
          showPayeeSummaryPage: true,
          showLoader: false,
          summaryDetails: response,
          callCOP: false,
        });
        this.showHeader(false);
      }
    } else if (response.code === 422) {
      const beneficiaryFailedHeader =
        response.status === 408
          ? this.props.content.beneficiaryFailedHeader
          : '';
      const message =
        response.error && response.error.code
          ? IncorrectFormatPayeeErrorMsg
          : _.get(response, 'coded_exceptions[0]', 0)
          ? _.get(response, 'coded_exceptions[0].error_status', '')
          : duplicatePayeeErrrmsg;

      const beneficiaryFailedBody =
        response.status === 408
          ? this.props.content.beneficiaryFailedBody
          : message;
      const {
        account_number,
        display_name,
        name,
        reference,
        single_use,
        sort_code,
      } = MoveMoneyPayeeStore.getAddPayeeDetails();

      this.setState({
        addPayeeError: true,
        showHedaerResponse: beneficiaryFailedHeader,
        addPayeeResponse: beneficiaryFailedBody,
        showLoader: false,
        callCOP: false,
        account_number,
        sort_code,
        reference,
        name,
        isNicknameEnable: !single_use,
        display_name,
        showBackButtonOnTop: true,
      });
    }

    if (this.state.addPayeeResponse === 'Invalid Account') {
      this.showHideInlineError('sortCodeErr', 'sort_code', true);
      this.showHideInlineError('accNumErr', 'account_number', true);
      this.setState({
        fieldValid: {
          name: true,
          sort_code: false,
          account_number: false,
          reference: true,
          display_name: true,
        },
      });
    }
  }

  getErrorMessage(name) {
    switch (name) {
      case 'name':
        return this.props.content.personCompanyErrorMessage;
      case 'reference':
        return this.props.content.referenceErrorMessage;
      case 'sort_code':
        return this.props.content.sortCodeErrorMessage;
      case 'account_number':
        return this.props.content.accountNumberErrorMessage;
      case 'display_name':
        return this.props.content.nicknameErrorMessage;
      default:
        break;
    }
  }

  getFormatedSortCode(sortCode) {
    let sortCodeValue = '';
    const replacedSortCode = sortCode.replace(/-/g, '');
    _.map(replacedSortCode, (data, index) => {
      if (index % 2 == 0 && index > 0) {
        sortCodeValue += `-${data}`;
      } else {
        sortCodeValue += data;
      }
    });
    return sortCodeValue;
  }

  getNameHeader() {
    return this.props.comingFromCompanySearch
      ? this.props.content.nameOfTheCompany
      : this.props.content.nameOfThePerson;
  }

  getNameHelperText() {
    return this.props.comingFromCompanySearch
      ? this.props.content.nameOfTheCompanyHelpText
      : this.props.content.nameOfThePersonHelpText;
  }
  getRenderContent() {
    let content;
    const { isSMEUser } = this.props;
    if (this.state.showLoader) {
      content = <LoaderComponent type="large" />;
      return content;
    }
    if (this.state.showPayeeSummaryPage) {
      content = (
        <AddPayeeSummary
          goToMoveMoneyPage={this.goToMoveMoneyPage}
          summaryDetails={this.state.summaryDetails}
          goToManagePayees={this.goToManagePayees}
          content={this.props.content}
          isSMEUser={isSMEUser}
        />
      );
      return content;
    }
    content = (
      <div>
        {this.showBackButtononTop()}

        {this.showAddPayeePerson()}
        <div className="add-edit-payee__form__options">
          <button
            type="button"
            className="c-btn c-btn--secondary"
            onClick={this.goBackToMoveMoney}
          >
            Back
          </button>
          <button
            data-test-id="add-person-continue-button"
            type="button"
            className="c-btn c-btn--default"
            onClick={this.addPayeeConfirm}
          >
            Continue
          </button>
        </div>
        {this.state.addPayeeError ? this.checkForError() : ''}
      </div>
    );
    return content;
  }

  addPayeeConfirm() {
    this.props.setNickNameStatus(this.state.isNicknameEnable);
    const {
      isSMEUser,
      accntSelection,
      showInlineError,
      showCopComponent,
      comingFromCompanySearch,
    } = this.props;
    doErrorExist = false;

    if (this.state.isNicknameEnable) {
      if (
        !this.state.fieldValid['display_name'] &&
        this.state.addPayeeResponse === ''
      ) {
        this.showHideInlineError('nicknameErr', 'display_name', true);
        this.refs.nickName.focus();
        doErrorExist = true;
      }
    }

    if (
      !this.state.fieldValid['reference'] &&
      this.state.addPayeeResponse === ''
    ) {
      this.showHideInlineError('refErr', 'reference', true);
      this.refs.Reference.focus();
      doErrorExist = true;
    }

    if (
      !this.state.fieldValid['sort_code'] &&
      this.state.addPayeeResponse === ''
    ) {
      this.showHideInlineError('sortCodeErr', 'sort_code', true);
      this.refs.sortCode.focus();
      window.scrollTo(0, 0);
      doErrorExist = true;
    }

    if (
      !this.state.fieldValid['account_number'] &&
      this.state.addPayeeResponse === ''
    ) {
      this.showHideInlineError('accNumErr', 'account_number', true);
      this.refs.accountNumber.focus();
      window.scrollTo(0, 0);
      doErrorExist = true;
    }

    if (!this.state.fieldValid['name'] && this.state.addPayeeResponse === '') {
      this.showHideInlineError('personErr', 'name', true);
      this.refs.personName.focus();
      window.scrollTo(0, 0);
      doErrorExist = true;
    }

    if (this.isAddingSameAccount()) {
      return;
    }
    if (!accntSelection) {
      showInlineError('accntErr', 'dropdown-custom-menu', true);
      window.scrollTo(0, 0);
      doErrorExist = true;
    }

    if (this.state.addPayeeResponse === 'Invalid Account') {
      const oneFieldInvalid =
        !this.state.fieldValid['sort_code'] ||
        !this.state.fieldValid['account_number'];
      const bothFieldsInvalid =
        !this.state.fieldValid['sort_code'] &&
        !this.state.fieldValid['account_number'];
      // if one SCAN field is updated, user can proceed
      doErrorExist = oneFieldInvalid ? false : bothFieldsInvalid;
    }

    if (!doErrorExist) {
      this.setState({
        addPayeeFlag: false,
        showPayeeFlag: false,
        addPayeeConfirmFlag: true,
        showError: false,
        showPayeeSummaryPage: false,
      });

      const formData = this.updateStore();
      this.showHeader(false);
      this.setState({ showLoader: true });
      showCopComponent(formData, comingFromCompanySearch);
      AnalyticsUtil.analyticAction(
        config.analytics.analytics_experience_activity,
        config.analytics.analytics_event_method_interacted,
        config.analytics.analytics_name_add_payee,
        'click'
      );
      if (isSMEUser) {
        const selectedAccount = MoveMoneyPayeeStore.getSelectedAccount();
        const beneficiaryEventData = beneficiaryCreateEventPayload(
          formData,
          selectedAccount
        );
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          beneficiaryEventData,
          'click',
          true
        );
      }
    }
  }

  checkError(fieldname, fieldAmount, parent) {
    switch (fieldname) {
      case 'name':
        if (fieldAmount === '') {
          if (this.state.fieldBlurred[fieldname]) {
            this.showHideInlineError(parent, fieldname, true);
          }
          this.state.fieldValid[fieldname] = false;
        } else {
          this.showHideInlineError(parent, fieldname, false);
          this.state.fieldValid[fieldname] = true;
        }
        break;
      case 'sort_code':
        if (fieldAmount === '' || fieldAmount.length < 6) {
          if (this.state.fieldBlurred[fieldname]) {
            this.showHideInlineError(parent, fieldname, true);
          }
          this.state.fieldValid[fieldname] = false;
        } else {
          this.showHideInlineError(parent, fieldname, false);
          this.state.fieldValid[fieldname] = true;
        }
        break;
      case 'account_number':
        if (fieldAmount === '' || fieldAmount.length < 8) {
          if (this.state.fieldBlurred[fieldname]) {
            this.showHideInlineError(parent, fieldname, true);
          }
          this.state.fieldValid[fieldname] = false;
        } else {
          this.showHideInlineError(parent, fieldname, false);
          this.state.fieldValid[fieldname] = true;
        }
        break;
      case 'reference':
        if (fieldAmount === '') {
          if (this.state.fieldBlurred[fieldname]) {
            this.showHideInlineError(parent, fieldname, true);
          }
          this.state.fieldValid[fieldname] = false;
        } else {
          this.showHideInlineError(parent, fieldname, false);
          this.state.fieldValid[fieldname] = true;
        }
        break;
      case 'display_name':
        if (fieldAmount === '') {
          if (this.state.fieldBlurred[fieldname]) {
            this.showHideInlineError(parent, fieldname, true);
          }
          this.state.fieldValid[fieldname] = false;
        } else {
          this.showHideInlineError(parent, fieldname, false);
          this.state.fieldValid[fieldname] = true;
        }
        break;
      default:
        break;
    }
  }

  checkForError() {
    const response = MoveMoneyPayeeStore.getAddPayeeResponse();
    let footerButtons = (
      <div>
        <button
          data-test-id="close-error-modal-button"
          className="c-btn c-btn--default c-modal__button"
          onClick={this.closeErrorModal}
        >
          {response.status === 408 && isBOrVMRetail() ? 'OK, got it' : 'OK'}
        </button>
      </div>
    );
    const {
      content: { duplicatePayeeErrrmsg },
    } = this.props;
    let content = (
      <PatternLibModalComponent
        show={this.state.addPayeeError}
        customClass={'c-modal'}
        onHide={() =>
          this.closeErrorModal(
            this.state.addPayeeResponse === duplicatePayeeErrrmsg
          )
        }
        bsSize={'medium'}
        modalHeading={this.state.showHedaerResponse}
        modalBody={this.state.addPayeeResponse}
        modalFooter={footerButtons}
        modalInContainer={false}
        closeButton
      />
    );
    return content;
  }

  closeErrorModal(isDuplicate) {
    let { fieldValid, addPayeeResponse } = this.state;
    if (isDuplicate) {
      fieldValid = {
        name: true,
        sort_code: true,
        account_number: true,
        reference: true,
        display_name: true,
      };
      addPayeeResponse = '';
    }
    this.setState({
      showLoader: false,
      addPayeeError: false,
      fieldValid,
      addPayeeResponse,
    });

    this.props.onErrorModalClose();
  }

  // handled for add company manually
  goBackToMoveMoney() {
    if (this.props.comingFromCompanySearch) {
      this.props.goBackToSearchCompany();
    } else {
      this.props.goBackToMoveMoney();
      MoveMoneyPayeeStore.resetStore();
    }
  }

  goToManagePayees() {
    this.props.goToManagePayees();
  }

  goToMoveMoneyPage(props) {
    this.props.goToMoveMoneyPage(props);
  }

  handleRadioClick() {
    if (this.state.isNicknameEnable) {
      this.setState({
        isNicknameEnable: false,
        display_name: '',
        nFlag: false,
      });
    } else this.setState({ isNicknameEnable: true });
  }

  handleSMEAddPayee(response) {
    Promise.all([setSMEPaymentToAccount(response)]).then(() => {
      this.props.goBackToMoveMoney();
    });
  }

  isAddingSameAccount() {
    let fromAccountSelected = MoveMoneyPayeeStore.getSelectedAccount();
    if (
      this.removeHypenFromString(this.state.sort_code) ===
        fromAccountSelected.sortCode &&
      this.state.account_number === fromAccountSelected.accountNumber
    ) {
      let addingSameaccError =
        'You seem to be paying money into the same account that you’re withdrawing it from.';
      this.setState({
        addPayeeError: true,
        addPayeeResponse: addingSameaccError,
      });
      return true;
    }
    return false;
  }

  moveFocusOnSortCode(e) {
    if (e.target.name === this.props.content.payeeRequestPacket_sort_code) {
      this.updateValueState(
        e.target.name,
        this.removeHypenFromString(e.target.value)
      );
    }
  }

  removeHypenFromString(value) {
    let sortedValue = '';
    _.map(value, (data) => {
      if (data !== '-') {
        sortedValue += data;
      }
    });
    return sortedValue;
  }

  showAddPayeePerson() {
    let sortcodeValue = this.state.sort_code;
    const { isFromManagePayee } = this.props;
    const { showMoreInfo } = this.state;
    return (
      <ConditionalPanel isVisible>
        <div className="c-field" ref="personErr">
          <label
            className="c-field__label c-field__label--block"
            htmlFor="personName1"
          >
            {this.getNameHeader()}
            <div className="c-field__instructions">
              {this.getNameHelperText()}
            </div>
          </label>
          <div className="c-field__controls">
            <input
              aria-invalid="false"
              aria-required="true"
              aria-live="personErr1"
              className="c-field__input"
              onBlur={this.onBlur}
              type="text"
              name={this.props.content.payeeRequestPacket_Name}
              data-parent="personErr"
              id="personName1"
              onChange={this.onChange}
              maxLength="138"
              size="138"
              value={this.state.name}
              ref="personName"
            />
            <div
              role="alert"
              id="personErr1"
              className="c-field__message"
              ref={this.props.content.payeeRequestPacket_Name}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm1-9">
            <div className="c-field" ref="sortCodeErr">
              <label
                className="c-field__label c-field__label--block"
                htmlFor="sortCode1"
              >
                {this.props.content.theirSortCode}
              </label>
              <div className="c-field__controls">
                <input
                  aria-invalid="false"
                  aria-required="true"
                  aria-live="sortCodeErr1"
                  className="c-field__input"
                  onBlur={this.onBlur}
                  data-parent="sortCodeErr"
                  onFocus={this.moveFocusOnSortCode}
                  type="text"
                  name={this.props.content.payeeRequestPacket_sort_code}
                  id="sortCode1"
                  onChange={this.onChange}
                  maxLength="8"
                  size="8"
                  value={sortcodeValue}
                  ref="sortCode"
                />
                <div
                  role="alert"
                  id="sortCodeErr1"
                  className="c-field__message"
                  ref={this.props.content.payeeRequestPacket_sort_code}
                />
              </div>
            </div>
          </div>
          <div className="col-sm1-9">
            <div className="c-field" ref="accNumErr">
              <label
                className="c-field__label c-field__label--block"
                htmlFor="accNo"
              >
                {this.props.content.theirAccountNo}
              </label>
              <div className="c-field__controls">
                <input
                  aria-invalid="false"
                  aria-required="true"
                  aria-live="accNumErr1"
                  className="c-field__input"
                  onBlur={this.onBlur}
                  data-parent="accNumErr"
                  type="text"
                  name={this.props.content.payeeRequestPacket_account_number}
                  id="accNo"
                  onChange={this.onChange}
                  maxLength="8"
                  size="8"
                  value={this.state.account_number}
                  ref="accountNumber"
                />
                <div
                  role="alert"
                  id="accNumErr1"
                  className="c-field__message"
                  ref={this.props.content.payeeRequestPacket_account_number}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="c-field" ref="refErr">
          <label
            className="c-field__label c-field__label--block"
            htmlFor="reference"
          >
            {this.props.content.reference}
            <div className="c-field__instructions">
              {this.props.content.referenceNumberTextAddPayee}
            </div>
          </label>
          <div className="c-field__controls">
            <input
              aria-invalid="false"
              aria-required="true"
              aria-live="refErr1"
              className="c-field__input"
              onBlur={this.onBlur}
              data-parent="refErr"
              type="text"
              name={this.props.content.payeeRequestPacket_reference}
              id="reference"
              onChange={this.onChange}
              value={this.state.reference}
              maxLength="18"
              size="18"
              ref="Reference"
            />
            <div
              role="alert"
              id="refErr1"
              className="c-field__message"
              ref={this.props.content.payeeRequestPacket_reference}
            />
          </div>
        </div>
        {!isFromManagePayee && (
          <div className="c-field c-field--checkbox">
            <label className="c-field__label">
              <input
                aria-label={this.props.content.addPayeeCheckboxText1}
                className="c-field__input"
                type="checkbox"
                defaultChecked={this.state.isNicknameEnable}
                onChange={this.handleRadioClick}
              />
              <span>{this.props.content.addPayeeCheckboxText1}</span>
            </label>
            <div className="c-field__extra">
              {this.props.content.addPayeeCheckboxText2}
              <div className="web-ui-components">
                <Popover
                  id="popover-more-info"
                  isOpen={showMoreInfo}
                  content={this.props.content.addPayeeMoreInfoText}
                  onClick={() => this.setState({ showMoreInfo: !showMoreInfo })}
                >
                  <Icon iconType="InfoOutlineLarge" size="xs" />
                </Popover>
              </div>
            </div>
          </div>
        )}
        {this.state.isNicknameEnable || isFromManagePayee ? (
          <div className="c-field" ref="nicknameErr">
            <label
              className="c-field__label c-field__label--block"
              htmlFor="nickName"
            >
              {this.props.content.addPayeeNickName}
              <div className="c-field__instructions">
                {this.props.content.nicknameHintText}
              </div>
            </label>
            <div className="c-field__controls">
              <input
                className="c-field__input"
                onBlur={this.onBlur}
                type="text"
                name={this.props.content.payeeRequestPacket_nick_name}
                id="nickName"
                data-parent="nicknameErr"
                onChange={this.onChange}
                value={this.state.display_name}
                ref="nickName"
                maxLength="50"
                size="50"
                aria-live="nicknameErr1"
                aria-invalid="false"
              />
              <div
                id="nicknameErr1"
                className="c-field__message"
                ref={this.props.content.payeeRequestPacket_nick_name}
                role="alert"
              />
            </div>
          </div>
        ) : (
          ''
        )}
      </ConditionalPanel>
    );
  }

  showBackButtononTop() {
    let content = (
      <StepHeader
        showheaderCrumbs="true"
        headerTitle={this.props.content.payeeHeader}
        onClick={this.goBackToMoveMoney}
        headerCrumbsMessage={this.props.content.back}
      />
    );
    return this.props.comingFromCompanySearch || this.state.showBackButtonOnTop
      ? content
      : ' ';
  }

  showHeader(val) {
    this.props.showHeader(val);
  }

  showHideInlineError(parent, name, isShowError) {
    const {
      content: { duplicatePayeeErrrmsg },
    } = this.props;
    if (isShowError) {
      this.refs[parent].className += ' c-field--error';
      this.refs[name].innerHTML = this.getErrorMessage(name);
    } else if (
      (isShowError && this.state[name] !== '') ||
      (isShowError &&
        this.state.addPayeeResponse !== duplicatePayeeErrrmsg &&
        this.state.addPayeeResponse !== 'Invalid Account' &&
        this.state.addPayeeResponse !== '')
    ) {
      this.refs[parent].className = 'c-field';
      this.refs[name].innerHTML = '';
    } else {
      this.refs[parent].className = 'c-field';
      this.refs[name].innerHTML = '';
    }
  }

  sortKeyUp() {
    let v = this.refs.sortCode.value;
    if (v.match(/^\d{2}$/) !== null) {
      this.refs.sortCode.value = `${v}-`;
    } else if (v.match(/^\d{2}-\d{2}$/) !== null) {
      this.refs.sortCode.value = `${v}-`;
    }
  }

  updateStore() {
    const { isFromManagePayee } = this.props;
    // add payee service payload
    /* {"single_use":false,"name":"fasfasfdsa","display_name":"xxxxxxx","sort_code":"xxxxxx","account_number":"vvvvvvv","reference":"tertewt"}*/
    let formObjectRef = {};
    formObjectRef.account_number = this.state.account_number;
    formObjectRef.sort_code = this.removeHypenFromString(this.state.sort_code);
    formObjectRef.name = this.state.name;
    formObjectRef.single_use = isFromManagePayee
      ? !isFromManagePayee
      : !this.state.isNicknameEnable;
    formObjectRef.display_name = this.state.display_name.trim();
    formObjectRef.reference = this.state.reference.trim();
    MoveMoneyPayeeActionCreator.updateCompanyFormManually(formObjectRef);
    return formObjectRef;
  }

  updateValueState(name, value) {
    this.setState({
      [name]: value,
    });
  }

  updateValueState(name, value) {
    this.setState({
      [name]: value,
    });
  }

  render() {
    return (
      <div>
        {/* <span id="accessH1ID" ref="accessH1ID" tabIndex="0" className="u-visually-hidden off-screen"> You are on {this.props.content.payeeHeader}</span> */}
        {this.getRenderContent()}
      </div>
    );
  }
}

AddPersonComponent.propTypes = {
  content: PropTypes.object,
  comingFromCompanySearch: PropTypes.bool,
  manualDetails: PropTypes.object,
  goToManagePayees: PropTypes.func,
  goToMoveMoneyPage: PropTypes.func,
  goBackToMoveMoney: PropTypes.func,
  goBackToSearchCompany: PropTypes.func,
  showHeader: PropTypes.func,
  isFromManagePayee: PropTypes.bool.isRequired,
  isSMEUser: PropTypes.bool.isRequired,
  accntSelection: PropTypes.bool,
  showInlineError: PropTypes.func,
  showCopComponent: PropTypes.func,
  selectedPayee: PropTypes.object,
  setNickNameStatus: PropTypes.func,
  keyFieldsChanged: PropTypes.func.isRequired,
  onErrorModalClose: PropTypes.func.isRequired,
};
AddPersonComponent.defaultProps = {
  content: {},
  summaryDetails: {},
  comingFromCompanySearch: false,
};
export default AddPersonComponent;
